// extracted by mini-css-extract-plugin
module.exports = {"container":"DefaultLayout_container__2pL5u"};